import React from "react";
import { Flex, Typography } from "antd";
import { useNavigate } from "react-router";
import Icon from "../../../../../Icon";
import ButtonComponent from "../../../../../Components/Button";

const { Text } = Typography;

const NoBusinessAccountPlaceholder = () => {
  const navigate = useNavigate();

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={12}
      style={{ minHeight: 300, textAlign: "center", padding: "0 24px" }}
    >
      <Icon type="add_account" style={{ fontSize: 36 }} />
      <Text strong>Create a business account to access this page</Text>
      <Text type="secondary" style={{ maxWidth: 360 }}>
        Mastercard monitoring is only available once a business account has
        been created. Finish setting one up to see your ECP &amp; EFM status
        here.
      </Text>
      <ButtonComponent type="primary" onClick={() => navigate("/onboarding/business-info")}>
        Create business account
      </ButtonComponent>
    </Flex>
  );
};

export default NoBusinessAccountPlaceholder;
